import { X } from 'lucide-react';
import { Toast as RadixToast } from 'radix-ui';
import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

export const ToastProvider = RadixToast.Provider;

export function ToastViewport({ label }: { label: string }) {
  return (
    <RadixToast.Viewport
      label={label}
      className="fixed bottom-4 left-4 z-[60] flex w-[min(360px,calc(100vw-32px))] flex-col gap-2 outline-none"
    />
  );
}

export interface ToastProps {
  message: ReactNode;
  action?: { label: string; onAction: () => void };
  closeLabel: string;
  tone?: 'neutral' | 'error';
  onOpenChange: (open: boolean) => void;
}

export function Toast({ message, action, closeLabel, tone = 'neutral', onOpenChange }: ToastProps) {
  return (
    <RadixToast.Root
      duration={6000}
      onOpenChange={onOpenChange}
      className={cn(
        'flex animate-scale-in items-center gap-3 rounded-lg bg-bg-2 py-2 pr-2 pl-3 text-sm shadow-popover',
        tone === 'error' && 'border-l-2 border-status-critical',
      )}
    >
      <RadixToast.Description className="min-w-0 flex-1 text-text-1">
        {message}
      </RadixToast.Description>
      {action && (
        <RadixToast.Action altText={action.label} asChild>
          <button
            type="button"
            onClick={action.onAction}
            className="h-6 rounded-md px-2 text-xs font-medium text-accent outline-none hover:bg-bg-3 focus-visible:ring-2 focus-visible:ring-focus"
          >
            {action.label}
          </button>
        </RadixToast.Action>
      )}
      <RadixToast.Close
        aria-label={closeLabel}
        className="inline-flex size-6 items-center justify-center rounded-md text-text-3 outline-none hover:bg-bg-3 hover:text-text-1 focus-visible:ring-2 focus-visible:ring-focus"
      >
        <X className="size-3.5" />
      </RadixToast.Close>
    </RadixToast.Root>
  );
}
